const { getModulesWithContainersPath } = require('~/webpack/require-context')

const requireContext = require.context(`containers/`, true, /\/Assets\/js\/autoload\/admin\/index\.js$/)
const modules = getModulesWithContainersPath(requireContext, [key => key.replace(/\/index\.js$/, '')]).defaults()
export default modules
